export default (options) => {
  return (options.entityType === 2 ? 'Our' : 'My') + ' Exclusive Listings';
};


// WEBPACK FOOTER //
// ./src/components/my-listings/header.js